
import copy from './copyComment.js';
import imgError from './imgCheck.js';
import ringsLoading from '../../directives/ringsLoading/index.js';
import loading from '@/directives/loading/src/index.js';
// 自定义指令
const directives = {
  copy,
  ringsLoading,
  imgError,
  loading
};
// 这种写法可以批量注册指令
export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key]);
    });
  }
}



// WEBPACK FOOTER //
// ./src/util/toolClass/directives.js